import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "pb-10 pb-lg-12" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder text-dark" }, "Funding Round")
], -1)
const _hoisted_3 = { class: "fv-row mb-10" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Name", -1)
const _hoisted_5 = { class: "fv-row mb-10" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "required form-label" }, " Investment Required", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-exclamation-circle ms-2 fs-7",
  "data-bs-toggle": "popover",
  "data-bs-trigger": "hover",
  "data-bs-html": "true"
}, null, -1)
const _hoisted_8 = {
  class: "input-group mb-3",
  style: {"margin-top":"6px"}
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", {
  class: "input-group-text",
  style: {"border":"none"}
}, "£", -1)
const _hoisted_10 = { class: "fv-row mb-10" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "required form-label" }, "Pre-Money Valuation", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-exclamation-circle ms-2 fs-7",
  "data-bs-toggle": "popover",
  "data-bs-trigger": "hover",
  "data-bs-html": "true"
}, null, -1)
const _hoisted_13 = {
  class: "input-group mb-3",
  style: {"margin-top":"6px"}
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", {
  class: "input-group-text",
  style: {"border":"none"}
}, "£", -1)
const _hoisted_15 = { class: "fv-row mb-10" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "required form-label" }, "Minimum Investment", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-exclamation-circle ms-2 fs-7",
  "data-bs-toggle": "popover",
  "data-bs-trigger": "hover",
  "data-bs-html": "true"
}, null, -1)
const _hoisted_18 = {
  class: "input-group mb-3",
  style: {"margin-top":"6px"}
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", {
  class: "input-group-text",
  style: {"border":"none"}
}, "£", -1)
const _hoisted_20 = { class: "fv-row mb-10" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Opens At"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "popover",
    "data-bs-trigger": "hover",
    "data-bs-html": "true"
  })
], -1)
const _hoisted_22 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_23 = {
  key: 1,
  style: {"color":"red"}
}
const _hoisted_24 = { class: "fv-row mb-10" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Closes At"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "popover",
    "data-bs-trigger": "hover",
    "data-bs-html": "true"
  })
], -1)
const _hoisted_26 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_27 = {
  key: 1,
  style: {"color":"red"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_Field, {
        onBlur: _ctx.createDraft,
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.fieldChanged($event))),
        name: "fundingRoundName",
        class: "form-control form-control-lg form-control-solid",
        modelValue: _ctx.fundingRoundName,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.fundingRoundName) = $event))
      }, null, 8, ["onBlur", "modelValue"]),
      _createVNode(_component_ErrorMessage, {
        name: "fundingRoundName",
        class: "fv-plugins-message-container invalid-feedback"
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode(_component_Field, {
          onBlur: _ctx.createDraft,
          as: "input",
          type: "text",
          onInput: _cache[2] || (_cache[2] = ($event: any) => {
            _ctx.fieldChanged($event);
            _ctx.formatInput($event);
          }),
          style: {"background-color":"#f5f8fa"},
          onKeypress: _cache[3] || (_cache[3] = ($event: any) => (_ctx.limitInput($event))),
          name: "fundingRoundInvestmentRequired",
          class: "form-control py-4 form-control-lg form-control-solid",
          modelValue: _ctx.fundingRoundInvestmentRequired,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.fundingRoundInvestmentRequired) = $event))
        }, null, 8, ["onBlur", "modelValue"]),
        _createVNode(_component_ErrorMessage, {
          name: "fundingRoundInvestmentRequired",
          class: "fv-plugins-message-container invalid-feedback"
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _hoisted_12,
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createVNode(_component_Field, {
          onBlur: _ctx.createDraft,
          as: "input",
          type: "text",
          onInput: _cache[5] || (_cache[5] = ($event: any) => {
            _ctx.fieldChanged($event);
            _ctx.formatInput($event);
          }),
          style: {"background-color":"#f5f8fa"},
          onKeypress: _cache[6] || (_cache[6] = ($event: any) => (_ctx.limitInput($event))),
          name: "fundingRoundPreMoneyValuation",
          class: "form-control py-4 form-control-lg form-control-solid",
          modelValue: _ctx.fundingRoundPreMoneyValuation,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.fundingRoundPreMoneyValuation) = $event))
        }, null, 8, ["onBlur", "modelValue"]),
        _createVNode(_component_ErrorMessage, {
          name: "fundingRoundPreMoneyValuation",
          class: "fv-plugins-message-container invalid-feedback"
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _hoisted_16,
      _hoisted_17,
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _createVNode(_component_Field, {
          onBlur: _ctx.createDraft,
          as: "input",
          type: "text",
          onInput: _cache[8] || (_cache[8] = ($event: any) => {
            _ctx.fieldChanged($event);
            _ctx.formatInput($event);
          }),
          style: {"background-color":"#f5f8fa"},
          onKeypress: _cache[9] || (_cache[9] = ($event: any) => (_ctx.limitInput($event))),
          name: "fundingRoundMinimumInvestment",
          class: "form-control py-4 form-control-lg form-control-solid",
          modelValue: _ctx.fundingRoundMinimumInvestment,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.fundingRoundMinimumInvestment) = $event))
        }, null, 8, ["onBlur", "modelValue"]),
        _createVNode(_component_ErrorMessage, {
          name: "fundingRoundMinimumInvestment",
          class: "fv-plugins-message-container invalid-feedback"
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _hoisted_21,
      _createVNode(_component_el_date_picker, {
        name: "fundingRoundOpensAt",
        type: "date",
        modelValue: _ctx.opensAt,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.opensAt) = $event)),
        placeholder: "Pick a Starting Date",
        format: "DD-MM-YYYY"
      }, null, 8, ["modelValue"]),
      (!_ctx.opensAtAdded)
        ? (_openBlock(), _createElementBlock("p", _hoisted_22, "Start Date is required!"))
        : _createCommentVNode("", true),
      (_ctx.dateCheck)
        ? (_openBlock(), _createElementBlock("p", _hoisted_23, " Start Date must be smaller than End Date "))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_24, [
      _hoisted_25,
      _createVNode(_component_el_date_picker, {
        name: "fundingRoundClosesAt",
        type: "date",
        modelValue: _ctx.closesAt,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.closesAt) = $event)),
        placeholder: "Pick an Ending Date",
        format: "DD-MM-YYYY"
      }, null, 8, ["modelValue"]),
      (!_ctx.closesAtAdded)
        ? (_openBlock(), _createElementBlock("p", _hoisted_26, "End Date is required!"))
        : _createCommentVNode("", true),
      (_ctx.dateCheck)
        ? (_openBlock(), _createElementBlock("p", _hoisted_27, " End Date must be greater than Start Date "))
        : _createCommentVNode("", true)
    ])
  ]))
}